// Vendors
import React, { useEffect } from 'react';

// Components
import { Locator, GoogleMapsLoader } from './components';

const PropaneSupplierSearch = (props) => {
  let placesService = null;
  let getNextPage = null;

  function handleGoogleMapsLoad() {
    placesService = new google.maps.places.PlacesService(
      document.createElement('div')
    );
  }

  function computeDistance(coordsA, coordsB) {
    return google.maps.geometry.spherical.computeDistanceBetween(
      new google.maps.LatLng(coordsA[1], coordsA[0]),
      new google.maps.LatLng(coordsB[1], coordsB[0])
    );
  }

  function getDetails(placeId) {
    return new Promise((resolve, reject) => {
      placesService.getDetails(
        {
          placeId,
          fields: [
            'formatted_address',
            'formatted_phone_number',
            'opening_hours',
            'website'
          ]
        },
        (place, status) => {
          if (status == google.maps.places.PlacesServiceStatus.OK) {
            resolve(place);
          } else {
            reject('Unable to find place details.');
          }
        }
      );
    });
  }

  function loadMore() {
    if (getNextPage) {
      getNextPage();
    }
  }

  function searchNearby(coords, radius, callback) {
    const location = new google.maps.LatLng(coords[1], coords[0]);
    placesService.nearbySearch(
      {
        keyword: 'propane supplier',
        location,
        radius: Number(radius)
        // TODO: Keeping this here until we decide to implement the "rankBy" setting
        //rankBy: google.maps.places.RankBy.DISTANCE,
      },
      (results, status, pagination) => {
        getNextPage = null;

        if (pagination.hasNextPage) {
          getNextPage = () => {
            pagination.nextPage();
          };
        }

        if (status === google.maps.places.PlacesServiceStatus.OK) {
          const resultsInRadius = [];

          results.forEach((result) => {
            if (
              google.maps.geometry.spherical.computeDistanceBetween(
                result.geometry.location,
                location
              ) < Number(radius)
            ) {
              resultsInRadius.push(result);
            }
          });

          const places = results.map((result) => ({
            id: result.place_id,
            hasDetails: false,
            distance: null,
            location: [
              result.geometry.location.lng(),
              result.geometry.location.lat()
            ],
            details: {
              formatted_address: result.formatted_address,
              name: result.name
            }
          }));
          callback(null, places, pagination.hasNextPage);
        } else {
          callback('Unable to find places nearby.');
        }
      }
    );
  }

  return (
    <GoogleMapsLoader
      onLoad={handleGoogleMapsLoad}
      render={() => (
        <Locator
          computeDistance={computeDistance}
          getDetails={getDetails}
          hasRadialSearch={true}
          loadMore={loadMore}
          searchNearby={searchNearby}
          {...props}
        />
      )}
    />
  );
};

export default PropaneSupplierSearch;
